<div>
<mat-form-field appearance="outline">
  <mat-label>{{ label }}</mat-label>

  <mat-chip-grid #chipGrid>
    <!-- Render selected filters as chips -->
    @for (user of selectedUsers; track user) {
    <mat-chip-row (removed)="removeUser(user)">
      <span class="chip-value">{{ user?.hawkId }}</span>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip-row>
    }

    <!-- Input field for new filters -->
    <input matInput [formControl]="filterControl" [matAutocomplete]="auto" [matChipInputFor]="chipGrid"
      (matChipInputTokenEnd)="addFreeTextFilter($event)" (keydown.enter)="handleEnterKey($event)" placeholder="Search"
      appearance="fill" />
    <button mat-icon-button matSuffix (click)="addFromADGroup($event)"
      title="Add from AD groups..."><mat-icon>group_add</mat-icon></button>
    <button mat-icon-button matSuffix
      (click)="inputElement.value = ''; selectedUsers = [];"><mat-icon>clear</mat-icon></button>
  </mat-chip-grid>

  <!-- Autocomplete for chip names -->
  <mat-autocomplete #auto (optionSelected)="selectUser($event)" autoActiveFirstOption>
    @for (user of options | async; track user) {
    <mat-option [value]="user">
      {{ user.displayName }} ({{ user.hawkId }})
    </mat-option>
    }
  </mat-autocomplete>

  <mat-hint>{{ hint }}</mat-hint>
  @if (loading | async) {
  <div class="loading">
    <mat-spinner [diameter]="25"></mat-spinner>
  </div>
  }
</mat-form-field>
</div>
@if (recentADGroups.length) {
<div class="recent-ad-groups">
  <mat-chip-set aria-label="Recent AD group selection" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="dropChip($event)">
    @for (adGroup of recentADGroups; track $index) {
    <mat-chip (removed)="removeRecentGroup(adGroup)" (click)="addFromGroup(adGroup)"
      [title]="'Click to add any valid TKS members from the AD group, \'' + adGroup + '.\''">
        <mat-icon matChipAvatar>group_add</mat-icon>
      {{adGroup}}
      <button matChipRemove [attr.aria-label]="'Remove ' + adGroup" [title]="'Remove AD group \'' + adGroup + '\' from favorites.'">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
    }
  </mat-chip-set>
</div>
}